module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_1_a96ffb02b085aacf89e8a5bef1515eb1.png";